/*
Interface to get the url of a given image type i.e. a logo image
*/

class ImageUrlProcurerInterface {
    /*
    @param  (string) imageCode  the identifier of the image

    @return undefined or url string
    */
    procure = (imageCode) => {
        throw new Error("procure method not implemented");
    }
}

export default ImageUrlProcurerInterface;